<template>
  <div class="row">
    <div class="col-12">
      <div class="col-12">
        <div class="card">
          <div class="card-header">
            <h1>Create Vocabulary</h1>
          </div>
        </div>
      </div>

      <div class="col-12">
        <div class="card-header">
          <strong>General</strong>
        </div>
        <div class="card form-horizontal">
          <div class="row">
            <div class="col-12">
              <div class="card-block">
                <div class="form-group row">
                  <label for="title" class="col-md-2">Name *</label>
                  <div class="col-md-10">
                    <input
                      id="name"
                      v-model="entity.name"
                      type="text"
                      placeholder="Enter name"
                      class="form-control"
                    >
                  </div>
                </div>

                <div class="form-group row">
                  <label for="bio" class="col-md-2">Body</label>
                  <div class="col-md-10">
                    <ckeditor id="body" v-model="entity.body" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 mb-5">
        <button class="btn btn-success" @click="save">
          Save
          <span class="btn-loader" style="display: none;" />
        </button>

        <div class="saving-alerts" style="margin-top: 20px;">
          <div class="alert alert-success" style="display: none;">
            Vocabulary has created successful!
          </div>
          <div class="alert alert-danger" style="display: none;">
            {{ saveErrorMessage }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Mixins
import CreatePageMixin from '@/mixins/CreatePageMixin';

export default {
  name: 'VocabularyNew',
  mixins: [CreatePageMixin],
  data() {
    return {
      entity: {
        name: null,
        body: null,
      },
    };
  },
  methods: {
    isEntityValid() {
      if (!this.entity.name) {
        this.$_showError('Title field is required');
        return false;
      }
      return true;
    },
    saveRequest() {
      const postFormData = new FormData();
      postFormData.append('name', this.entity.name);
      if (this.entity.body) postFormData.append('body', this.entity.body);

      return this.$apiHttp.post(`${this.$config.app_api.prefix}vocabularies`, postFormData);
    },
    save() {
      $('.saving-alerts .alert').hide();
      $('.btn-success .btn-loader').show();
      if (!this.isEntityValid()) return;
      this.saveRequest().then((response) => {
        this.$_successSave();
        this.$parent.getSource();
        window.location.hash = `#/admin/taxonomy/vocabulary/edit/${response.data.id}`;
      }).catch((error) => {
        this.$_errorSave(error);
        console.error('Error in create vocabulary query', error);
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// New.vue?33ecf4a0